import { NewCustomBackgroundComponent, ProductMain, useWindowWidth } from '@prishapolicy/shared/ui';
import { NextSeo } from 'next-seo';
import Image from 'next/image';
import {
  Faq,
  HeroTicker,
  InsuranceForDoctorsFormTypeProvider,
  useInsuranceForDoctorsFormType,
  WhyChooseUs,
  BasicFlowForm,
  MoreOffersForm,
  CoverageDetailsForm,
} from '@prishapolicy/w3/ui';
import { insuranceForDoctorsFaqList } from '@prishapolicy/backend-core/masters';
import rightBgImage from './right-bg.png';
import rightBgImageMobile from './right-bg-mobile.png';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { trpcNoAuth } from '@prishapolicy/shared/trpc';

// http://localhost/insurance-for-doctors/?productType=professional-indemnity-for-doctors
// http://localhost/insurance-for-doctors/?productType=professional-indemnity-for-medical-setup
// http://localhost/insurance-for-doctors/?productType=motor-insurance
// http://localhost/insurance-for-doctors/?productType=health-insurance
// http://localhost/insurance-for-doctors/?productType=home-insurance
// http://localhost/insurance-for-doctors/?productType=cyber-insurance

// type ProductType =
//   | 'professional-indemnity-for-doctors'
//   | 'professional-indemnity-for-medical-setup'
//   | 'motor-insurance'
//   | 'health-insurance'
//   | 'home-insurance'
//   | 'cyber-insurance';

const description = 'Carefully crafted for those who serve as the spine of our economy.';

export function InsuranceForDoctors() {
  const { width } = useWindowWidth(0);

  const router = useRouter();
  // const { productType } = router.query;
  // const currentProductType = productType as ProductType;

  const { mutate } = trpcNoAuth['lead-management']['lead']['first-time-lead-for-doctors'].useMutation();

  useEffect(() => {
    if (!router.isReady) return;

    const { email, name, phone } = router.query;

    if (email && name && phone) {
      const nameParts = (name as string).split('+');

      let firstName = '';
      let lastName = '';

      if (nameParts.length > 1) {
        lastName = nameParts[nameParts.length - 1];
        firstName = nameParts.slice(0, nameParts.length - 1).join(' ');
      } else {
        firstName = nameParts[0];
        lastName = nameParts[0];
      }

      mutate({
        firstNameFromParams: firstName as string,
        lastNameFromParams: lastName as string,
        emailFromParams: email as string,
        mobileNumberFromParams: phone as string,
      });
    } else {
      console.log('Required parameters are missing or URL is not in the expected format.');
    }
  }, [router.isReady, router.query, mutate]);

  return (
    <>
      <NextSeo description={description} title="Insurance For Doctors | PrishaPolicy" />

      <ProductMain color="blue">
        <div className={` ${width >= 1280 ? '!mb-0' : 'mb-[308px] lg:mb-28'}`}>
          <InsuranceForDoctorsFormTypeProvider>
            <NewCustomBackgroundComponent
              InsuranceForDoctorsFormRender={InsuranceForDoctorsForm}
              backgroundColor="blue-300"
            >
              <div className="relative">
                <div
                  className={`2xl::ml-10 relative ${
                    width > 1280 ? 'z-0' : 'z-10'
                  } ml-5 mt-16 flex flex-col justify-between pt-10 2xl:mt-28`}
                >
                  <HeaderSection />
                </div>

                <div className="relative">
                  <Image src={require('./Updated.png')} alt="motor insurance" className="" />
                </div>

                {width >= 1280 ? (
                  <div className="absolute top-0 right-0 bottom-0  z-0 flex items-center justify-end overflow-hidden">
                    <Image src={rightBgImage} alt="motor insurance" className="h-full " />
                  </div>
                ) : (
                  <div className="absolute top-0 right-0 overflow-hidden">
                    <Image src={rightBgImageMobile} alt="motor insurance" className="h-full" />
                  </div>
                )}
              </div>
            </NewCustomBackgroundComponent>
          </InsuranceForDoctorsFormTypeProvider>
        </div>
        <div className={` ${width >= 1280 ? '!pt-0' : 'pt-[350px] lg:pt-[550px]'} `}>
          <HeroTicker />

          <WhyChooseUs />
          <Faq list={insuranceForDoctorsFaqList} />
        </div>
      </ProductMain>
    </>
  );
}

const InsuranceForDoctorsForm = () => {
  const { formType, setBasicFlowForm, setMoreOffersForm, formInfo } = useInsuranceForDoctorsFormType();

  const isBasicFormFilled = !!formInfo.emailId;

  const renderedForm =
    formType === 'basic-flow-form' ? (
      <BasicFlowForm />
    ) : formType === 'coverage-details-form' ? (
      <CoverageDetailsForm />
    ) : formType === 'more-offers-form' ? (
      <MoreOffersForm />
    ) : null;

  // const navItems = [
  //   { id: 'basic-flow-form', label: 'Basic Info', action: setBasicFlowForm, enabled: true },
  //   {
  //     id: 'coverage-details-form',
  //     label: 'Coverage Details',
  //     action: setCoverageDetailsForm,
  //     enabled: isBasicFormFilled,
  //   },
  //   { id: 'more-offers-form', label: 'More Offers', action: setMoreOffersForm, enabled: isCoverageDetailsFormFilled },
  // ];

  const navItems = [
    { id: 'basic-flow-form', label: 'Basic Info', action: setBasicFlowForm, enabled: true },
    { id: 'more-offers-form', label: 'More Offers', action: setMoreOffersForm, enabled: isBasicFormFilled },
  ];

  return (
    <div>
      <div className="flex items-center gap-2 p-5">
        {navItems.map((item) => (
          <>
            <div
              onClick={item.enabled ? item.action : null}
              className={`text-body-3 hover:cursor-pointer ${formType === item.id ? 'font-bold' : 'text-grey-800'} ${
                !item.enabled ? 'text-grey-400 hover:cursor-not-allowed' : ''
              }`}
            >
              {item.label}
            </div>
            {item.id !== 'more-offers-form' && <ArrowRightDoubleLineIcon />}
          </>
        ))}
      </div>
      {renderedForm}
    </div>
  );
};

const ArrowRightDoubleLineIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M15.9702 10L10.7976 4.82742L9.61913 6.00593L13.6132 10L9.61913 13.9941L10.7976 15.1726L15.9702 10ZM11.262 10L6.0894 4.82742L4.91089 6.00593L8.90496 10L4.91089 13.9941L6.0894 15.1726L11.262 10Z"
        fill="#BABABA"
      />
    </svg>
  );
};

const HeaderSection = () => {
  const { width } = useWindowWidth(0);
  const texts = [
    'Professional Indemnity For Doctors',
    'Cyber Insurance For Doctors',
    'Motor Insurance For Doctors',
    'Health Insurance For Doctors',
    'Home Insurance For Doctors',
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleTextChange = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
  };

  const renderHeading = () => {
    return (
      <>
        <style>
          {`
          @keyframes typewriter {
            0% {
              width: 0;
            }
            50% {
              width: 100%;
            }
            100% {
              width: 0;
            }
          }
          .typewriter-text {
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            animation: typewriter 4.5s steps(40, end) infinite;
          }
        `}
        </style>
        <h1
          className="text-primary overflow-hidden whitespace-nowrap pb-3 text-[40px] font-extrabold lg:text-[60px]"
          style={{
            width: 'fit-content',
          }}
          onAnimationIteration={handleTextChange}
        >
          {width > 492 ? (
            <>
              <div>
                <span className="typewriter-text inline">
                  {texts[currentIndex].split(' ')[0]} {texts[currentIndex].split(' ')[1]}
                </span>
                <br />
                <span className="block">{texts[currentIndex].split(' ').slice(2).join(' ')}</span>
              </div>
            </>
          ) : (
            <div className="block">
              <div className="inline-block">
                <span className="typewriter-text">{texts[currentIndex].split(' ')[0]}</span>
                <br />
                <span className="typewriter-text">{texts[currentIndex].split(' ')[1]}</span>
              </div>
              <br />
              <span>{texts[currentIndex].split(' ').slice(2).join(' ')}</span>
            </div>
          )}
        </h1>
      </>
    );
  };

  return (
    <div>
      <p className="text-title-7 text-primary font-medium">#WeCareForYou</p>
      {renderHeading()}

      <p className="text-title-6 font-medium lg:text-[22px]">{description}</p>
    </div>
  );
};

export default InsuranceForDoctors;
